import { render, staticRenderFns } from "./virtualAcct.vue?vue&type=template&id=a6d5da34&scoped=true"
import script from "./virtualAcct.vue?vue&type=script&lang=ts"
export * from "./virtualAcct.vue?vue&type=script&lang=ts"
import style0 from "./virtualAcct.vue?vue&type=style&index=0&id=a6d5da34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d5da34",
  null
  
)

export default component.exports